// Cells whose first character is one of these are interpreted as formulas
// by Excel / Google Sheets / LibreOffice. Prepending a single apostrophe
// neutralizes them without modifying display elsewhere.
const FORMULA_PREFIX_CHARS = ["=", "+", "-", "@", "\t", "\r"];

export const escapeCsvCell = (value) => {
  if (value == null) return value;
  if (typeof value !== "string") return value;
  if (value.length === 0) return value;
  return FORMULA_PREFIX_CHARS.includes(value[0]) ? `'${value}` : value;
};

export const sanitizeCsvRows = (rows) =>
  rows.map((row) => {
    const out = {};
    for (const key of Object.keys(row)) out[key] = escapeCsvCell(row[key]);
    return out;
  });
